export enum ServerError {
  InvalidCredentials = 'invalid_credentials',
  InvalidResponseData = 'invalid_response_data',
  InvalidAuthToken = 'invalid_auth_token',
  AccessTokenExpired = 'invalid_auth_token',
  UnexpectedError = 'unexpected_error',
  AgentAlreadyExists = 'agent_already_exists',
  DuplicateUsername = 'duplicate_username',
  AccountCreationFailed = 'glympse_account_failed',
  InvalidArguments = 'invalid_arguments',
  InvalidOrg = 'invalid_org',
  InvalidAccess = 'invalid_access',
  FailedToCreate = 'failed_to_create',
  FailedToSignup = 'failed_to_signup',
  TokenHasExpired = 'oauth_token',
  InvalidToken = 'invalid_token',
}

export const ServerErrorMessages: { [key in ServerError]: string } = {
  [ServerError.InvalidCredentials]: 'Whoops! That username and password combination didn\'t seem to work. Please try again.',
  [ServerError.InvalidResponseData]: 'Unknown error happened. Please contact Glympse support!',
  [ServerError.InvalidAuthToken]: 'Invalid auth token',
  [ServerError.AccessTokenExpired]: 'Access token expired',
  [ServerError.UnexpectedError]: 'Unknown error happened. Please contact Glympse support!',
  [ServerError.AgentAlreadyExists]: 'We recognize that you are a Glympse user. At this time, you\'ll need to register for Glympse Pro with a different email address than what you use for Glympse.',
  [ServerError.DuplicateUsername]: 'User with this email address already exists in our system, please use another email address',
  [ServerError.AccountCreationFailed]: 'Unfortunately, something went wrong! We can\'t create a new account.',
  [ServerError.InvalidOrg]: 'Whoops! Looks like you passed the wrong organization id.',
  [ServerError.InvalidArguments]: 'Whoops! Looks like you passed the wrong arguments.',
  [ServerError.InvalidAccess]: 'Your access level is not sufficient to make the change.',
  [ServerError.FailedToCreate]: 'Sorry, we were unable to create your organization, please complete all fields.',
  [ServerError.FailedToSignup]: 'Sorry, we were unable to sign you up, please try again.',
  [ServerError.TokenHasExpired]: 'Access token expired.',
  [ServerError.InvalidToken]: 'Invalid token'
};
